const BARE_ELO_LABEL = /^(ELO|EOL)\s*\d+\s*$/i;

function cleanName(value) {
  if (value == null) return '';
  return String(value)
    .replace(/\.{3,}/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}

function isBareEloLabel(value) {
  return BARE_ELO_LABEL.test(cleanName(value));
}

function nameFromEloTitle(value) {
  const title = cleanName(value);
  if (!title || isBareEloLabel(title)) return '';
  const colon = title.indexOf(':');
  if (colon > 0 && /^(ELO|EOL)\s*\d+/i.test(title.slice(0, colon))) {
    const afterColon = title.slice(colon + 1).trim();
    if (afterColon.length >= 3) return afterColon;
  }
  return title;
}

/**
 * Module name shown on the assignment canvas (suggested_module_title).
 * Content generation must use this so tabs do not fall back to ELO1, ELO2, …
 */
export function outcomeModuleDisplayName(outcome, fallbackIndex = 0) {
  if (!outcome || typeof outcome !== 'object') {
    return `ELO ${fallbackIndex + 1}`;
  }

  const suggested = cleanName(
    outcome.suggested_module_title || outcome.module_title || outcome.module_name
  );
  if (suggested && !isBareEloLabel(suggested)) return suggested;

  const fromTitle = nameFromEloTitle(outcome.title) || nameFromEloTitle(outcome.outcome);
  if (fromTitle) return fromTitle;

  const elo = cleanName(outcome.elo_number);
  if (elo) return elo;
  return `ELO ${fallbackIndex + 1}`;
}
